import { Box, BoxProps } from '@mui/material';

export type LoanIconProps = BoxProps & {
  white?: boolean;
};

export const LoanIcon: React.FC<LoanIconProps> = ({ white, ...props }) => {
  return (
    <Box className="md-icon material-icons" display="inline-block" bgcolor="red" {...props}>
      {white ? (
        <img alt="Loan Icon" src={new URL('/public/images/icons/loan_white.png', import.meta.url).toString()} />
      ) : (
        <img alt="Loan Icon" src={new URL('/public/images/icons/loan.png', import.meta.url).toString()} />
      )}
    </Box>
  );
};
